/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useState } from "react";
import Picker from "react-mobile-picker";
import { useTranslation } from "react-i18next";
import CustomButton from "../CustomButton";
import "./styles.scss";

function getDayArray(year, month) {
  const dayCount = new Date(year, month, 0).getDate();
  return Array.from({ length: dayCount }, (_, i) =>
    String(i + 1).padStart(2, "0")
  );
}

const WheelPicker = ({ isModalOpen, onClose, onConfirm, name }) => {
  const { t } = useTranslation();

  const [pickerValue, setPickerValue] = useState({
    year: "",
    month: "",
    day: "",
    monthName: "",
  });
  const [errorMessage, setErrorMessage] = useState("");

  const month = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const handlePickerChange = useCallback(
    (newValue, key) => {
      setErrorMessage("");

      const updatedValue = { ...pickerValue, [key]: newValue[key] };

      if (key === "month") {
        const monthIndex = Number(newValue.month) - 1;
        updatedValue.monthName = month[monthIndex];
      }

      if (key !== "day") {
        const newDayArray = getDayArray(
          Number(updatedValue.year),
          Number(updatedValue.month)
        );
        const newDay = newDayArray.includes(updatedValue.day)
          ? updatedValue.day
          : newDayArray[newDayArray.length - 1];
        updatedValue.day = newDay;
      }

      setPickerValue(updatedValue, true);
    },
    [pickerValue]
  );

  const handleOnConfirm = () => {
    if (pickerValue.year && pickerValue.month && pickerValue.day) {
      onConfirm({
        target: {
          name,
          value: `${pickerValue.year}-${pickerValue.month}-${pickerValue.day}`,
        },
      });
    } else {
      setErrorMessage(t("date-filter-modal.date_filter_error_message_3"));
    }
  };

  if (!isModalOpen) {
    return null;
  }

  return (
    <div className={`container`}>
      <div className="modal-container">
        <div className="modal-content">
          <div className={`date-container`}>
            <p className={`title-text`}>{t("global.date")}</p>
            <p className={`title-text`}>
              {pickerValue.monthName.substring(0, 3)} {pickerValue.day},{" "}
              {pickerValue.year}
            </p>
          </div>
          <Picker
            value={pickerValue}
            onChange={handlePickerChange}
            wheelMode="normal"
          >
            <Picker.Column name="month">
              {month.map((month, index) => (
                <Picker.Item
                  key={month}
                  value={String(index + 1).padStart(2, "0")}
                >
                  {({ selected }) => (
                    <div
                      className={selected ? "selected-date" : "unselected-date"}
                    >
                      {month}
                    </div>
                  )}
                </Picker.Item>
              ))}
            </Picker.Column>
            <Picker.Column name="day">
              {getDayArray(
                Number(pickerValue.year),
                Number(pickerValue.month)
              ).map(day => (
                <Picker.Item key={day} value={day}>
                  {({ selected }) => (
                    <div
                      className={selected ? "selected-date" : "unselected-date"}
                    >
                      {day}
                    </div>
                  )}
                </Picker.Item>
              ))}
            </Picker.Column>
            <Picker.Column name="year">
              {Array.from({ length: 200 }, (_, i) => `${1923 + i}`).map(
                year => (
                  <Picker.Item key={year} value={year}>
                    {({ selected }) => (
                      <div
                        className={
                          selected ? "selected-date" : "unselected-date"
                        }
                      >
                        {year}
                      </div>
                    )}
                  </Picker.Item>
                )
              )}
            </Picker.Column>
          </Picker>
          {errorMessage ? (
            <p className="wheel-picker-error">{errorMessage}</p>
          ) : null}
          <div className="wheel-picker-button-wrapper">
            <CustomButton
              text={t("global.cancel")}
              btnVariant="btn-outline-neutral-900"
              onClick={onClose}
            />
            <CustomButton text={t("global.done")} onClick={handleOnConfirm} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WheelPicker;
